import {
  AppliedPayableRestriction,
  CreditAppliedActionPayload,
  DocumentSelectionChangeEvent,
  ModifiedDocumentMeta,
  PaymentDetailsFormSubmitEvent,
  SessionDocumentInfo,
  UpdateAppliedDiscountAmountAction,
  ValidateCreditMemoErrors,
  ValidateInvoicePayableAmountErrors,
} from '@arc/unified-payments-frontend/shared-payment';
import { createAction, props } from '@ngrx/store';

export const paymentDetailsStepNavigated = createAction(
  '[Make Payment Component] Initialize',
);

export const initializePaymentDetailsFooterStep = createAction(
  '[Make Payment Component] Initialize Footer Step',
);

export const initialDataLoaded = createAction(
  '[Make Payment Component] Initial Data Loaded',
);

export const payableRestrictionsApplied = createAction(
  '[Make Payment Component] Payable Restrictions Applied',
  props<{
    payload: AppliedPayableRestriction[];
  }>(),
);

export const discountsUpdated = createAction(
  '[Make Payment Component] Discounts Updated',
  props<{
    payload: UpdateAppliedDiscountAmountAction;
  }>(),
);

export const creditPreApplied = createAction(
  '[Make Payment Component] Credit Pre Applied',
  props<{
    payload: CreditAppliedActionPayload;
  }>(),
);

export const creditApplied = createAction(
  '[Make Payment Component] Credit Applied',
  props<{
    payload: CreditAppliedActionPayload;
  }>(),
);

export const paymentDetailsStepSubmitted = createAction(
  '[Make Payment Component] Payment Details Step Submitted',
  props<{
    paymentDetails: PaymentDetailsFormSubmitEvent;
  }>(),
);

export const paymentDateSelected = createAction(
  '[Make Payment Component] Payment Date Selected',
  props<{
    paymentDate: Date;
  }>(),
);

export const validateCreditMemoPayableAmount = createAction(
  '[Make Payment Component] Validate Credit Memo Payable Amount',
  props<{
    document: SessionDocumentInfo;
  }>(),
);

export const creditMemoPayableAmountValidated = createAction(
  '[Make Payment Component] Credit Memo Payable Amount Validated',
  props<{
    document: SessionDocumentInfo;
    errors: ValidateCreditMemoErrors;
  }>(),
);

export const validateInvoicePayableAmount = createAction(
  '[Make Payment Component] Validate Invoice Payable Amount',
  props<{
    document: SessionDocumentInfo;
  }>(),
);

export const invoicePayableAmountValidated = createAction(
  '[Make Payment Component] Invoice Payable Amount Validated',
  props<{
    document: SessionDocumentInfo;
    errors: ValidateInvoicePayableAmountErrors;
  }>(),
);

export const updateModifiedDocumentsUrnListAction = createAction(
  '[Make Payment Component] Update Modified Documents Urn List',
  props<{
    document: ModifiedDocumentMeta;
  }>(),
);

export const documentSelectionChanged = createAction(
  '[Make Payment Component] Document Selection Changed',
  props<{
    event: DocumentSelectionChangeEvent;
  }>(),
);

export const applySoftBlockDocumentDeselection = createAction(
  '[Make Payment Component] Apply Soft Block Document Deselection',
);
export const signInBannerDismissed = createAction(
  '[Make Payment Component] Sign In Banner Dismissed',
);

export const emailVerificationPendingPopupClosed = createAction(
  '[Make Payment Component] Email Verification Pending Popup Closed',
);

export const continueAsGuestClicked = createAction(
  '[Make Payment Component] Continue As Guest Clicked',
  props<{
    paymentDetails: PaymentDetailsFormSubmitEvent;
  }>(),
);

export const signInBannerSignedIn = createAction(
  '[Make Payment Component] Sign In Banner Signed In',
  props<{ username: string }>(),
);

export const signInResendLink = createAction(
  '[Make Payment Component] Sign In Resend Link',
);

export const signInChangeUsername = createAction(
  '[Make Payment Component] Sign In Change Username',
);
